import { useSelector } from "react-redux"
import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"
import { useApartadaCountdown } from "../../../../hooks/useApartadaCountdown"
import { useMaxWidthContext } from "../../../hooks/useMaxWidth"
import { RootState } from "src/store/store"

import "../Blocked/Blocked.css"

const Apartada = ({ roomNumber, roomTypeName, dateStatusChanged, hasIncidences }: RoomStatusProps) => {
    const { timeLeft } = useApartadaCountdown(dateStatusChanged)
    const { maxWidth } = useMaxWidthContext()

    const { roomsDimensions } = useSelector((state: RootState) => state.rooms)

    const itemHeight = `calc(calc(80dvh - 240px) / ${(roomsDimensions?.x || 1) * 4})`

    return (
        <Wrapper bgColor={"var(--card-gray)"} hasIncidences={hasIncidences}>
            <RoomCardHeader
                hasIncidences={hasIncidences}
                roomNumber={roomNumber}
                iconBgColor="var(--bloqueada)"
                iconName="LockFill"
                roomTypeAbbreviation={roomTypeName?.[0]}
            ></RoomCardHeader>
            <RoomCardBody>
                <div style={{ maxWidth }} className="room-card--xs--blocked__description__wrapper">
                    <span className="room-card--xs--blocked__timer" style={{ fontSize: itemHeight }}>
                        {timeLeft}
                    </span>
                    <span className="room-card--xs--blocked__description" style={{ fontSize: itemHeight }}>
                        Apartada
                    </span>
                </div>
            </RoomCardBody>
        </Wrapper>
    )
}

export default Apartada
